import card from '@/api/administration/card-profile'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  customers: [],
  cardTypes: [],
  cardStatus: [],
  edit_data: {}
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_CUSTOMER(state, customers) {
    state.customers = customers
  },
  RECEIVE_CARD_TYPE(state, cardTypes) {
    state.cardTypes = cardTypes
  },
  RECEIVE_CARD_STATUS(state, cardStatus) {
    state.cardStatus = cardStatus
  },
  SET_EDIT_DATA(state, edit_data) {
    let {
      activated_date,
      card_number,
      card_status,
      card_type,
      customer,
      status_change_by,
      status_change_date,
      status_reason,
      user_change_status,
      ...resource
    } = edit_data
    state.edit_data = resource
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return card.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return card.store(data)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await card.find(id)
      context.commit('SET_EDIT_DATA', response.data)
      return Promise.resolve(response.data)
    }
  },
  update(context, data) {
    return card.update(data)
  },
  statusChange(context, data) {
    return card.statusChange(data)
  },
  async dataBeforeCreate(context) {
    if (!context.state.customers.length > 0) {
      let response = await card.getCustomer()
      context.commit('RECEIVE_CUSTOMER', response)
    }
    if (!context.state.cardTypes.length > 0) {
      let response = await card.getCardType()
      context.commit('RECEIVE_CARD_TYPE', response)
    }
    if (!context.state.cardStatus.length > 0) {
      let response = await card.getCardStatus()
      context.commit('RECEIVE_CARD_STATUS', response)
    }
  }
}
